import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	item: {
		fontSize: 16,
		textAlign: "center",
		[theme.breakpoints.up("md")]: {
			textAlign: "left"
		},
		[theme.breakpoints.up("lg")]: {
			fontSize: 19,
			width: "50%"
		}
	},
	title: {
		fontSize: "1.8em"
	},
	content: {
		"& a": {
			color: "#FFFFFF",
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap"
		},
		"@media all and (max-width: 360px)": {
			"& a": {
				fontSize: 15
			}
		}
	}
}));

export default styles;
